var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3057",
    d: "M0-682.665H20v20H0Z",
    transform: "translate(0 682.665)",
    fill: "#2179fe"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3051",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3053",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3055",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3061",
    transform: "translate(0.586 3.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3063",
    d: "M-336.51,0H-345.1a1.563,1.563,0,0,0-1.562,1.563v12.5a1.563,1.563,0,0,0,1.563,1.563h12.5a1.562,1.562,0,0,0,1.563-1.562V5.469",
    transform: "translate(346.666)",
    fill: "none",
    stroke: "#2179fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3065",
    transform: "translate(7.584 0.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3067",
    d: "M-384.378-80.8l-8.839,8.839-2.762.552.552-2.762,8.839-8.839a.781.781,0,0,1,1.1,0l1.1,1.1A.781.781,0,0,1-384.378-80.8Z",
    transform: "translate(395.979 83.235)",
    fill: "none",
    stroke: "#2179fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3069",
    transform: "translate(15.871 1.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3071",
    d: "M0,0,2.21,2.21",
    fill: "none",
    stroke: "#2179fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit Icon.844db060.svg";
export { ForwardRef as ReactComponent };